module.exports = __webpack_public_path__ + "img/ico-stores.4f9aa967.svg";